import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import SimpleCheckbox from '../../Checkbox/SimpleCheckbox';

export const CustomLabelCheckbox = ({
  id,
  checked,
  labelText,
  disabled,
  gap = 20,
  indeterminate,
}) => (
  <SimpleCheckbox
    id={id}
    label={labelText}
    checked={checked}
    disabled={disabled}
    indeterminate={indeterminate}
    gap={gap}
    withHoverEffect
    size="lg"
    className="checkbox-dropdown"
    wrapperElementType="div"
  />
);

CustomLabelCheckbox.propTypes = {
  id: T.oneOfType([T.string, T.number]).isRequired,
  checked: T.bool,
  disabled: T.bool,
  indeterminate: T.bool,
  gap: T.oneOfType([T.string, T.number]),
  labelText: T.node,
};

export const CustomLabelSwitch = ({
  checked,
  labelText,
  disabled,
}) => (
  <div className={cx('custom-label-switch', { checked, disabled })}>
    <span className="custom-label-switch-label" style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      {labelText}
    </span>
    <span className={cx('switch-btn', { disabled })} />
  </div>
);

CustomLabelSwitch.propTypes = {
  checked: T.bool,
  disabled: T.bool,
  labelText: T.node,
};
